
import { defineComponent, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import { Wmdata } from '@/views/dashboard/data-safe/screen-watermark/screen-watermark.service'
import { WatermarkDensityMatrix } from '@/views/dashboard/data-safe/screen-watermark/_enum/watermark-density'
import { WatermarkField } from '@/views/dashboard/data-safe/screen-watermark/_enum/watermark-field'
import { getWatermarkFieldExample } from '@/views/dashboard/data-safe/screen-watermark/_enum/screen-watermark-labels'

export default defineComponent({
  props: {
    wmdata: {
      type: Object as PropType<Wmdata>,
      default: () => ({}),
    },
  },

  setup () {
    const { t, locale } = useI18n()
    function fieldExample (field: string) {
      void locale.value
      return getWatermarkFieldExample(t, field)
    }
    return {
      WatermarkField,
      WatermarkDensityMatrix,
      fieldExample,
    }
  }
})
